<app-page-shell>
  <app-page-hero
    eyebrow="Workspace Self Service"
    title="My HR"
    subtitle="Personal workspace for leave, documents, timesheets, payslips, approvals, learning, and expenses.">
    <div nav>
      <app-my-hr-nav
        [summary]="summary"
        [canViewManager]="canViewManager"
        [canViewExpenses]="canViewExpenses"
        [canManageExpenses]="canManageExpenses"
        [canApproveExpenses]="canApproveExpenses"></app-my-hr-nav>
    </div>
    <div actions>
      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        label="Refresh"
        [outlined]="true"
        [loading]="loading"
        (click)="refresh()"></button>
    </div>
  </app-page-hero>

  <div class="my-hr-shell-content">
    <router-outlet></router-outlet>
  </div>
</app-page-shell>
